import {Form, Modal} from 'antd';
import {AccountInvoiceStatus, useUpdateAccountInvoiceMutation} from 'api/generated';
import {accountQuery} from 'api/queries';
import {AnchorLink} from 'components';
import {Formik} from 'formik';
import {FormItem, Select} from 'formik-antd';
import {FormikHelpers} from 'formik/dist/types';
import {accountInvoiceStatusLabels} from 'lib/labels';
import {enumKeys} from 'lib/utils';
import React, {useState} from 'react';
import * as yup from 'yup';
import {InvoiceProps} from './types';

const validationSchema = yup.object().shape({
  status: yup.string().oneOf(Object.values(AccountInvoiceStatus)).required('Status is required')
});

export const UpdateInvoice: React.FC<InvoiceProps> = ({invoice}) => {
  const [isOpen, setOpen] = useState(false);
  const [updateAccountInvoice] = useUpdateAccountInvoiceMutation();

  if (!invoice.id) {
    throw new Error('Invoice ID is required to update status');
  }

  const initialValues = {
    status: invoice.status || AccountInvoiceStatus.PAID
  };

  const handleSubmit = async (
    {status}: typeof initialValues,
    {setSubmitting}: FormikHelpers<typeof initialValues>
  ) => {
    try {
      await updateAccountInvoice({
        variables: {
          input: {
            id: invoice.id!,
            accountId: invoice.accountId,
            status
          }
        },
        refetchQueries: [{query: accountQuery, variables: {id: invoice.accountId}}]
      });
      setOpen(false);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <AnchorLink onClick={() => setOpen(true)}>update</AnchorLink>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={handleSubmit}>
        {({submitForm, isSubmitting, resetForm}) => (
          <Modal
            title="Update status"
            okText="Submit"
            open={isOpen}
            confirmLoading={isSubmitting}
            onOk={submitForm}
            afterClose={resetForm}
            onCancel={() => {
              setOpen(false);
            }}>
            <Form layout="vertical">
              <FormItem
                name="note"
                label="Invoice status"
                extra="If the status is set to Unpaid the account settlements will be automatically suspended.">
                <Select
                  name="status"
                  placeholder="Select a request reason"
                  options={enumKeys(AccountInvoiceStatus).map((key) => ({
                    value: key,
                    label: accountInvoiceStatusLabels[key]
                  }))}
                />
              </FormItem>
            </Form>
          </Modal>
        )}
      </Formik>
    </>
  );
};
